import React from 'react';
import { Box, Drawer, useTheme } from '@mui/material';
import SidebarContent from './SidebarContent';
import { sidebarStyles } from './Sidebar.styles';

const Sidebar = ({
  width = '260px',
  mobileOpen = false,
  onMobileClose = () => {},
  variant = 'permanent',
  isMobile = false,
}) => {
  const theme = useTheme();

  const sidebarContent = (
    <Box sx={sidebarStyles.sidebarContent(width)}>
      <SidebarContent />
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          '& .MuiDrawer-paper': sidebarStyles.drawerPaper(width, theme),
        }}
      >
        {sidebarContent}
      </Drawer>
    );
  }

  return (
    <Box sx={sidebarStyles.desktopSidebar(width)}>
      <SidebarContent />
    </Box>
  );
};

export default Sidebar;
